var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.844 0.00933329L12 0C12.3266 4.30807e-05 12.6418 0.119942 12.8858 0.336954C13.1299 0.553966 13.2858 0.852998 13.324 1.17733L13.3333 1.33333V10.6667H22.6667C22.9932 10.6667 23.3084 10.7866 23.5525 11.0036C23.7965 11.2206 23.9525 11.5197 23.9907 11.844L24 12C24 12.3266 23.8801 12.6418 23.663 12.8858C23.446 13.1299 23.147 13.2858 22.8227 13.324L22.6667 13.3333H13.3333V22.6667C13.3333 22.9932 13.2134 23.3084 12.9964 23.5525C12.7794 23.7965 12.4803 23.9525 12.156 23.9907L12 24C11.6734 24 11.3582 23.8801 11.1142 23.663C10.8701 23.446 10.7142 23.147 10.676 22.8227L10.6667 22.6667V13.3333H1.33333C1.00676 13.3333 0.691551 13.2134 0.447504 12.9964C0.203457 12.7794 0.0475429 12.4803 0.00933329 12.156L0 12C4.30807e-05 11.6734 0.119942 11.3582 0.336954 11.1142C0.553966 10.8701 0.852998 10.7142 1.17733 10.676L1.33333 10.6667H10.6667V1.33333C10.6667 1.00676 10.7866 0.691551 11.0036 0.447504C11.2206 0.203457 11.5197 0.0475429 11.844 0.00933329L12 0L11.844 0.00933329Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.1a6ceed494d55909752d8366341fef4a.svg";
export { ForwardRef as ReactComponent };